import { Flex, Space } from '@mantine/core';
import { useIntl } from 'react-intl';

import { CreateConversationWithAdminButton } from '@/features/chat/modules/CreateConversationWithAdminButton';
import { LBBackButton } from '@/shared/modules/back-button';
import { LBLinkButton } from '@/shared/ui-kit/components';

export const ScreenHeader = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <Space h={16} />
      <Flex align='center' justify='space-between'>
        <LBBackButton />
        <CreateConversationWithAdminButton>
          <LBLinkButton>{formatMessage({ id: 'commons.help' })}</LBLinkButton>
        </CreateConversationWithAdminButton>
      </Flex>
      <Space h={32} />
    </>
  );
};
